import { LinkAsLinkProps } from "@made-people/blueprint-link";

export const LinkAsLinkDefaults: LinkAsLinkProps = {
  // as: "span",
  variants: {
    size: {
      initial: "inherit",
    },
    style: "underline",
  },
};
